import '@/utils/envHeader'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/base.css'
import './assets/css/main.css'
import './assets/css/teacher-theme.css'
import './assets/css/teacher-responsive.css'
import './assets/css/report-print.css'
import { applyTeacherTheme } from './theme/applyTeacherTheme'
import Axios from 'axios'
import Router from 'vue-router';
import baseFun from './utils/base/base.js'
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
import moment from 'moment'
import eldragdialog from "./utils/directive";
import FastClick from 'fastclick'
if ('ontouchstart' in window) {
	FastClick.attach(document.body);
}

Vue.prototype.$recorretedDatas = {};
Vue.prototype.$machineId = MACHINE_ID
Vue.prototype.$moment = moment; //赋值使用
Vue.use(AlloyFingerPlugin, {
	AlloyFinger
})
Vue.prototype.$baseFun = baseFun;
Vue.prototype.$axios = Axios
Vue.use(Router);
Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false
Vue.directive('focus', {
	inserted: function (el) {
		const input = el.querySelector('textarea') ||
			el.querySelector('input') ||
			el.querySelector('.el-input__inner')
		if (input) {
			input.focus()
		} else {
			el.focus()
		}
	}
  })
Vue.directive('preventReClick', {
	inserted(el, binding) {
		el.addEventListener('click', () => {
			if (!el.disabled) {
				el.disabled = true
				setTimeout(() => {
					el.disabled = false
				}, binding.value || 2000)
			}
		})
	}
});
Vue.directive('eldragdialog', eldragdialog);

// CSP 阶段二: 内容内联样式 CSSOM 化(详见 @shared/utils/csp-style-shim.js)
// 全局垫片: 第三方库运行时 setAttribute('style') 重定向到 CSSOM, 严格 CSP 下不再被拦
import { deinlineStyles, applyDeinlinedStyles, installSetAttributeStyleShim } from '@shared/utils/csp-style-shim'
installSetAttributeStyleShim()
// v-csp-html: 与 v-html 行为等价, 注入内容先去内联化再 CSSOM 回填样式, 兼容无 unsafe-inline 的 CSP
Vue.directive('csp-html', {
	bind(el, binding) { setCspHtml(el, binding) },
	update(el, binding) { if (binding.oldValue !== binding.value) setCspHtml(el, binding) }
})
function setCspHtml(el, binding) {
	el.innerHTML = deinlineStyles(binding.value)
	applyDeinlinedStyles(el)
}

// 会话空闲超时监控（30分钟无操作自动退出）
import { Message } from 'element-ui'
const IDLE_TIMEOUT = 30 * 60 * 1000
let idleTimer = null
function resetIdleTimer() {
  idleTimer && clearTimeout(idleTimer)
  idleTimer = setTimeout(idleLogout, IDLE_TIMEOUT)
}
function idleLogout() {
  if (localStorage.length > 0) {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      if (localStorage.key(i).indexOf('zhiming') != -1) {
        localStorage.removeItem(localStorage.key(i))
      }
    }
  }
  sessionStorage.clear()
  store.dispatch('resetStore')
  Message.warning('会话已超时，请重新登录')
  router.push('/login')
  document.removeEventListener('mousemove', resetIdleTimer)
  document.removeEventListener('keydown', resetIdleTimer)
  document.removeEventListener('click', resetIdleTimer)
  document.removeEventListener('scroll', resetIdleTimer)
  document.removeEventListener('touchstart', resetIdleTimer)
}
document.addEventListener('mousemove', resetIdleTimer)
document.addEventListener('keydown', resetIdleTimer)
document.addEventListener('click', resetIdleTimer)
document.addEventListener('scroll', resetIdleTimer)
document.addEventListener('touchstart', resetIdleTimer)
resetIdleTimer()

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}
Vue.prototype.$store = store;
applyTeacherTheme(); // 挂载前应用教师端指挥舱HUD主题(注入--th-*变量+body主题class)
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

